import { Vue, Component, Prop, Watch, Setup } from "@wagich/vue-facing-decorator-metadata";
import { enforce, test } from "vest";
import { CustomFormField } from "../custom-form-field";

import { render } from "./checkbox-group-field.html";

@Component({
	render
})
export class CheckboxGroupField extends CustomFormField {
	get valueAsArray(): string[] {
		if (!Array.isArray(this.modelValue)) {
			return [];
		}
		return this.modelValue;
	}


	createValidator(data: any) {
		if (this.field.required) {
			test(this.field.name, "Bitte wählen Sie eine oder mehrere Optionen aus.", () => {
				enforce(data[this.field.name]).isArray().isNotEmpty();
			});
		}
	}

	onCheckboxInput(fieldValue: string, args: string[]) {
		let newValues: string[];

		if (args.includes(fieldValue)) {
			newValues = [...new Set([...this.valueAsArray, fieldValue])];
		} else {
			newValues = this.valueAsArray.filter(s => s !== fieldValue);
		}

		this.$emit("update:modelValue", newValues);
	}
}
